import React from 'react'

function BrandTwo() {
  return (
    <div>
        

        <div className="tmp-brand-section tmp-section-gapBottom">
            <div className="container">
                <div className="row">
                <div className="col-lg-12">
                    <div className="brand-main-wrapper-company">
                    <div className="tmp-brand-section-start">
                        <a href="#">
                        <img src="assets/images/brand/01.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/02.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/03.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/08.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/05.png" alt="brand" />
                        </a>
                    </div>
                    <div className="tmp-brand-section-start">
                        <a href="#">
                        <img src="assets/images/brand/06.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/07.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/08.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/09.png" alt="brand" />
                        </a>
                        <a href="#">
                        <img src="assets/images/brand/10.png" alt="brand" />
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>


    </div>
  )
}

export default BrandTwo